import { render } from "./Fancy-portfolio.vue?vue&type=template&id=79953bd8"
import script from "./Fancy-portfolio.vue?vue&type=script&lang=js"
export * from "./Fancy-portfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__